module.exports = __webpack_public_path__ + "static/media/36-8.e7735b0f.mp3";